import LabelsConfig from './LayerTypes/LabelsConfig';
import OutlineConfig from './LayerTypes/OutlineConfig';
import ChoroplethLayerConfig from './LayerTypes/ChoroplethLayerConfig';
import OtherLayerConfig from './LayerTypes/OtherLayerConfig';
import {
    Enums
} from './Config';

export default class LayersConfig {
    constructor(_config) {
        const labelsConfig = new LabelsConfig(_config);
        const outlineConfig = new OutlineConfig(_config);
        const choroplethLayerConfig = new ChoroplethLayerConfig(_config);
        const otherLayerConfig = new OtherLayerConfig(_config);

        this.maxWide = choroplethLayerConfig.zoomThreshold;
        this.minClose = choroplethLayerConfig.zoomThreshold - choroplethLayerConfig.overlap;

        this.layers = {
            labels: labelsConfig.layers,
            outlines: outlineConfig.layers,
            choropleth: choroplethLayerConfig.layers,
            other: otherLayerConfig.layers
        }

        this.layerArray = [this.layers.labels, this.layers.outlines, this.layers.choropleth, this.layers.other].flat();
        //this.layerArray = [this.layers.outlines, this.layers.other].flat();
        //TODO: Are choropleth layer array and label layer array redundant? Can't it just use layers.choropleth and layers.labels?
        this.choroplethLayerArray = this.layerArray.filter((l) => {
            if (l['source-layer']) {
                // console.log(l.id.replace('-wide',''))
                const layerDist = l.id.replace('-wide', '').replace('-outline', '').replace('-highlight', '');
                return layerDist === _config.enums.LEG_BODY.CONGRESS ||
                    layerDist === _config.enums.LEG_BODY.ST_UPPER ||
                    layerDist === _config.enums.LEG_BODY.ST_LOWER ||
                    layerDist === 'tract-vap' ||
                    layerDist === 'tract-cvap' ||
                    layerDist === 'voting-precincts';
            }
        });

        this.labelLayerArray = this.layerArray.filter((l) => {
            if (l['source-layer']) {
                // return l['source-layer'].includes('_us_centroid');
                return l['source-layer'].includes('centroids');
            }
        });

        this.layerArray.sort((a, b) => a.params.zIndex > b.params.zIndex ? 1 : -1);
        this.layerArray = this.layerArray.reverse();

       
    }
}